import { ChangeDetectorRef, Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { CARDS_STATUSES } from '../med-review-board-body/med-review-board-body.component';
import { HttpClient } from '@angular/common/http';
import { MedReviewService } from '../../services/med-review.service';
import { environment } from '../../../../../../environments/environment';

@Component({
  selector: 'kt-pv-review',
  templateUrl: './pv-review.component.html',
  styleUrls: ['./pv-review.component.scss'],
})
export class PvReviewComponent implements OnInit {
  @Input() data;
  @Input() closeDialog;
  prescriptionIndex = 1;
  totalPrescriptions = 1;
  patientReviewData = [];
  numberOfVerified = 0;

  @ViewChild('pic') pic: ElementRef;
  @ViewChild('imgR') imgR: ElementRef;
  hover: boolean;
  presImage = '';
  activeMedication: any = {};
  private patientReviewDataUniq: any[];
  private ngChangeCall = false;
  loadingTif = new BehaviorSubject(true);
  showDownloadBtn = false;
  PREFIX_MEDREVIEW_PV1_IMAGES = environment.PREFIX_MEDREVIEW_PV1_IMAGES;
  constructor(
    private cdr: ChangeDetectorRef,
    private http: HttpClient,
    private medReviewService: MedReviewService,
  ) {}

  ngOnInit(): void {
    this.patientReviewData = [];
    this.data.medications.forEach((e) => {
      if (e.is_verify === '0') {
        this.patientReviewData.push(e);
        this.totalPrescriptions = this.patientReviewData.length;
      }
    });
    const set1 = new Set([]);
    const set2 = new Set([]);
    this.patientReviewData.forEach((e, i) => {
      if (set2.has(e.document_path)) {
        return;
      }
      set2.add(e.document_path);
      set1.add({ data: e, index: i });
    });
    this.patientReviewDataUniq = Array.from(set1);
    this.totalPrescriptions = this.patientReviewDataUniq.length;
    this.activeMedication = this.patientReviewData[this.prescriptionIndex - 1];
    this.toDataURL(this.patientReviewDataUniq[this.prescriptionIndex - 1].data);
  }

  nextPrescriptions() {
    if (this.prescriptionIndex < this.totalPrescriptions) {
      this.prescriptionIndex++;
    }
    this.activeMedication = this.patientReviewDataUniq[this.prescriptionIndex - 1].data;
    this.toDataURL(this.patientReviewDataUniq[this.prescriptionIndex - 1].data);
  }

  previousPrescriptions() {
    if (this.prescriptionIndex > 1) {
      this.prescriptionIndex--;
    }
    this.activeMedication = this.patientReviewDataUniq[this.prescriptionIndex - 1].data;
    this.toDataURL(this.patientReviewDataUniq[this.prescriptionIndex - 1].data);
  }

  getCardClass(statusKey: string) {
    switch (statusKey) {
      case CARDS_STATUSES.CHANGED:
        return 'bg-orange';
      case CARDS_STATUSES.STARTED:
        return 'bg-green';
      case CARDS_STATUSES.RENEWED:
        return 'bg-blue';
      case CARDS_STATUSES.NOT_PRESCRIBER_OR_DISCONTINUED:
        return 'bg-grey';
    }
  }

  toDataURL(med) {
    let url = med.document_path;
    if (!med.presImage) {
      this.showDownloadBtn = false;
      const xhr = new XMLHttpRequest();
      xhr.responseType = 'arraybuffer';
      xhr.open('GET', this.PREFIX_MEDREVIEW_PV1_IMAGES + url);
      this.loadingTif.next(true);
      xhr.onload = () => {
        const tiff = new (window as any).Tiff({ buffer: xhr.response });
        const canvas = tiff.toCanvas();
        url = canvas.toDataURL('image/png');
        this.presImage = url;
        med.presImage = url;
        this.loadingTif.next(false);
        this.cdr.detectChanges();
      };
      xhr.onerror = () => {
        this.showDownloadBtn = true;
      };
      xhr.send();
    } else {
      this.presImage = med.presImage;
      this.cdr.detectChanges();
    }
  }
  triggerVerify(card, value) {
    card.is_verify = value;
    value === '1' ? this.numberOfVerified++ : this.numberOfVerified--;
    this.cdr.detectChanges();
  }

  getDoctorName(card) {
    return card.doctor_first_name + ' ' + card.doctor_last_name;
  }

  getType(medication: any) {
    switch (medication.type) {
      case 'O':
      case 'o':
        return 'Other';
      case 'E':
      case 'e':
        return 'Electronic';
      case 'P':
      case 'p':
        return 'PRN';
      case 'C':
      case 'c':
        return 'Maintenance';
    }
    return medication.type;
  }

  verifyCards() {
    this.numberOfVerified = 0;
    this.medReviewService
      .verifyMedications(
        (this.patientReviewData || [])
          .filter((e) => e.is_verify === '1')
          .map((e) => {
            return {
              id: e.id,
              rxno: e.rxno,
              office: e.prescription ? e.prescription.office_id : '0',
            };
          }),
      )
      .subscribe(() => {
        this.medReviewService.emitPV1Change();
        const unverified = (this.patientReviewData || []).filter((e) => e.is_verify !== '1');
        if (unverified.length) {
          // const activeUnverified = this.activeMedication.data.filter(e => e.is_verify != '1');
          // if(activeUnverified.length){
          this.ngChangeCall = true;
          this.ngOnInit();
          return;
          // }
        }
        this.closeDialog();
      });
  }

  triggerError(med, error, error_note) {
    this.medReviewService.markErrorOnMedications(med, error, error_note).subscribe(() => {
      // this.closeDialog();
    });
  }
}
